import React from 'react';
import { negate } from 'lodash-es';
import { WarrantyItemUsed } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-item-used/warranty-item-used';
import { VdpModule } from 'site-modules/shared/components/inventory/vdp-module/vdp-module';
import { InventoryEntities } from 'client/data/models/inventory';
import { isWarrantyItemEligible } from 'site-modules/shared/utils/inventory/warranty';
import { WarrantyExpiredBox } from 'site-modules/shared/components/inventory/warranty-module/warranty-expired-box/warranty-expired-box';

import './warranty-short-list-used.scss';

export function WarrantyShortListUsed(props) {
  const { warranty, vinData } = props;

  const firstExpiredWarranty = warranty.find(negate(isWarrantyItemEligible(vinData)));

  return (
    <VdpModule className="warranty-short-list-used bg-white px-1" withIndents={false}>
      <ul className="list-unstyled mb-0">
        {warranty.map(warrantyItem => (
          <li key={warrantyItem.id} className="py-1">
            {warrantyItem === firstExpiredWarranty && (
              <div className="mb-1">
                <WarrantyExpiredBox />
              </div>
            )}
            <WarrantyItemUsed warrantyItem={warrantyItem} vinData={vinData} />
          </li>
        ))}
      </ul>
    </VdpModule>
  );
}

WarrantyShortListUsed.propTypes = {
  warranty: InventoryEntities.Warranty.isRequired,
  vinData: InventoryEntities.InventoryVin.isRequired,
};
